import {NetworkEnums} from '../../../../shared/GameEnums.ts'
import type {SocketController} from './SocketController.ts'
import {ClientShuffleQueueController} from '../shuffle/ClientShuffleQueueController.ts'
import {type ShufflePlayerData, type ShuffleQueueData} from '../../../../shared/shuffle_queue/ShuffleInterfaces.ts'
import ShuffleState = NetworkEnums.ShuffleState

type ShuffleStateUpdateData = NetworkEnums.ShuffleStateUpdateData

export class SocketShuffleListen {
    // eslint-disable-next-line func-call-spacing
    private readonly shuffleStateHandlers = new Map<ShuffleState, (data: any) => void>()

    constructor(socketController: SocketController) {
        socketController.setStateHandler(NetworkEnums.State.ShuffleStateUpdate, (data: ShuffleStateUpdateData) => {
            this.shuffleStateHandlers.get(data.type)?.(data.payload)
        })

        this.shuffleStateHandlers.set(ShuffleState.ShuffleQueueData, (queueData: ShuffleQueueData) => {
            ClientShuffleQueueController.updateQueueData(queueData)
        })

        this.shuffleStateHandlers.set(ShuffleState.ShufflePlayerData, (playerData: ShufflePlayerData) => {
            ClientShuffleQueueController.updatePlayerData(playerData)
        })
    }
}

